import {Presenter} from '../../../Support/with_presenter';
import {CrewsService} from '../../../Network/CrewsService';
import {loadingResponse, NetworkResult} from '../../../Network/NetworkResult';
import {CrewInvite} from '../../../Models/CrewInvite';

export class CrewInvitesPresenter implements Presenter {
    public invites: NetworkResult<CrewInvite[]> = loadingResponse();

    public constructor(private crewService: CrewsService) {}

    public async mount(): Promise<void> {
        this.invites = await this.crewService.invites();
    }

    public unmount(): void {
        /* Noop */
    }

    public async onAcceptInviteClick(crewInvite: CrewInvite): Promise<void> {
        await this.crewService.acceptInvite(crewInvite.crewMembershipId);

        //Navigate to the crew page
        window.history.pushState({}, '', `/crews/${crewInvite.crew.id}`);
        window.dispatchEvent(new Event('popstate'));
    }

    public async onDeclineInviteClick(crewInvite: CrewInvite): Promise<void> {
        await this.crewService.removeMember(crewInvite.crewMembershipId);

        this.invites = await this.crewService.invites();
    }
}
